import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import axiosHelper from "../../../helpers/axios-helper";
import { errorMessage } from "../../../helpers/form-helper";
import DisableCheckbox from "../../shared/DisableCheckbox";
import DisabledFormElement from "../../shared/DisabledFormElement";
import EditDeleteButton from "../../shared/EditDeleteButton";
import SaveButton from "../../shared/SaveButton";
import SubContainer from "../../shared/SubContainer";

const WordSaveAndList = (props) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  const [wordList, setWordList] = useState([]);
  const [gameId, setGameId] = useState(props.gameId);
  const [resetWord, setResetWord] = useState();
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    getWords();
  }, []);

  useEffect(() => {
    reset({ en: "", tr: "", disabled: null });
  }, [resetWord]);

  const upload = (e) => {
    var uf = e.target.files[0];
    var fd = new FormData();
    fd.append("excel", uf, uf.name);
    setIsUploading(true);
    // toast.info("Yükleniyor...");

    const mid = toast.loading("Uploading...");

    axios
      .post(axiosHelper.axiosInstance.defaults.baseURL + "/word/savelist?gameId=" + props.gameId, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      })
      .then((data) => {
        toast.update(mid, {
          render: "Upload completed.",
          type: "success",
          isLoading: false,
          autoClose: true,
        });

        getWords();
      })
      .catch((err) => {
        toast.update(mid, {
          render: "Upload error.",
          type: "error",
          isLoading: false,
          autoClose: true,
        });

        // toast.error(error("Yükleme başarısız.", err));
        console.error(err);
      })
      .finally(() => {
        setIsUploading(false);
      });
  };

  const getWords = async () => {
    try {
      const response = await axiosHelper.get("/word/get", {
        params: { active: true, gameId: gameId },
      });
      setWordList(response.data);
    } catch (error) {
      axiosHelper.handleError(error);
    }
  };

  const onSubmit = async (data) => {
    try {
      data.game = gameId;
      const response = await axiosHelper.post("/word/save", data);
      
      let list = [...wordList];
      const index = list.findIndex((a) => a._id === response.data._id);

      if (index !== -1) {
        list.splice(index, 1, response.data);
      } else {
        list.push(response.data);
      }
      setResetWord(!resetWord);
      setWordList(list);
    } catch (error) {
      axiosHelper.handleError(error);
    }
  };

  const onClickEditDelete = async (type, id) => {
    if (type === "edit") {
      const word = wordList.find((a) => {
        return a._id === id;
      });
      reset(word);
    } else if (type === "del") {
      try {
        await axiosHelper.put("/word/delete/" + id);

        const list = wordList.filter((i) => {
          return i._id !== id;
        });

        setWordList(list);
      } catch (error) {
        axiosHelper.handleError(error);
      }
    }
  };

  const onDisabledChanged = async (id, disabled) => {
    try {
      await axiosHelper.put("/word/changedisabled/" + id, { d: disabled });

      let list = [...wordList];

      list.forEach((i) => {
        if (i._id === id) {
          i.disabled = disabled;
          return false;
        }
      });

      setWordList(list);
    } catch (error) {
      axiosHelper.handleError(error);
    }
  };

  return (
    <SubContainer>
      <div>
        <div className="row justify-content-between">
          <div className="col-auto">
            <h6 style={{ display: "inline-block" }}>Game's Words</h6>{" "}
            <span className="text-danger">{wordList?.length || 0} words</span>
          </div>
          <div className="col-auto ">
            <div>
              <label className="upload-input-label" htmlFor="excel">
                <span className="btn btn-sm btn-outline-success">
                  <i className="bi bi-file-earmark-excel-fill"></i> Import from
                  Excel
                </span>
              </label>
              <input
                disabled={isUploading}
                className="d-none"
                type="file"
                onChange={upload}
                id="excel"
              />
            </div>
          </div>
        </div>
        <hr />

        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <table className="table">
            <thead>
              <tr>
                <th>English</th>
                <th>Turkish</th>
                <th>Disable</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    maxLength="1000"
                    {...register("en", {
                      required: true,
                      maxLength: 1000,
                    })}
                  />
                  {errorMessage(errors.en)}
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    {...register("tr", {
                      required: true,
                      maxLength: 1000,
                    })}
                  />
                  {errorMessage(errors.tr)}
                </td>
                <td>
                  <DisabledFormElement register={register} />
                </td>
                <td className="text-end">
                  <SaveButton isSubmitting={isSubmitting} small={true} />
                </td>
              </tr>
              {wordList?.map((item) => {
                return (
                  <tr key={item._id}>
                    <td>{item.en}</td>
                    <td>{item.tr}</td>
                    <td>
                      <DisableCheckbox
                        checked={item.disabled}
                        id={item._id}
                        onChange={onDisabledChanged}
                      />
                    </td>
                    <td className="text-end">
                      <EditDeleteButton
                        id={item._id}
                        onClick={onClickEditDelete}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </form>
      </div>
    </SubContainer>
  );
};

export default WordSaveAndList;
